import { FieldErrors } from 'react-hook-form';
import { OneWayInServiceUpsertDto } from 'src/api/v2';
import useAboutForm from './use-about-form';
import useTargetForm from './use-target-form';
import useDeliveryForm from './use-delivery-form';
import useEeaForm from './use-eea-form';
import useContactInfoForm from './use-contact-info-form';
import { SetErrorFunction } from '../use-service-sub-form';
import { useEffect, useMemo, useRef, useCallback } from 'react';

const useSummaryForm = (
  data: OneWayInServiceUpsertDto,
  errors: FieldErrors<OneWayInServiceUpsertDto>,
  setErrors: SetErrorFunction<OneWayInServiceUpsertDto>,
) => {
  const isValidated = useRef(false);
  const updateDataDummy = useCallback(() => {}, []); // Summary should not update any data
  const about = useAboutForm({ data, updateData: updateDataDummy, errors, setErrors });
  const target = useTargetForm({ data, updateData: updateDataDummy, errors, setErrors });
  const contactInfo = useContactInfoForm({ data, updateData: updateDataDummy, errors, setErrors });
  const delivery = useDeliveryForm({ data, updateData: updateDataDummy, errors, setErrors });
  const eea = useEeaForm({ data, updateData: updateDataDummy, errors, setErrors });

  const forms = useMemo(
    () => [about, target, contactInfo, delivery, eea],
    [about, target, contactInfo, delivery, eea],
  );

  useEffect(() => {
    if (!isValidated.current) {
      forms.forEach((f) => f.form.trigger());

      isValidated.current = true;
    }
  }, [forms]);

  return { about, target, contactInfo, delivery, eea };
};

export default useSummaryForm;
